import ArrowBackIcon from '@mui/icons-material/ArrowBack'
import { Box, Stack, Typography } from '@mui/material'
import IconButton from '@mui/material/IconButton'
import type { FC, PropsWithChildren } from 'react'
import { useNavigate } from 'react-router-dom'
import { Breadcrumbs } from '@/components'
import { styles } from './styles'
import type { PageHeaderProps } from './types'

export const PageHeader: FC<PropsWithChildren<PageHeaderProps>> = (props) => {
  const {
    children,
    title,
    hasTabs,
    breadcrumbs,
    backUrl,
    buttons,
    status,
    backButton,
  } = props
  const navigate = useNavigate()

  return (
    <Box
      sx={{
        ...styles.pageHeader,
        paddingBottom: hasTabs ? 0 : '22px',
      }}
    >
      {breadcrumbs?.length && <Breadcrumbs items={breadcrumbs} />}

      <Stack direction="row" gap={2} alignItems={'center'}>
        {backUrl && (
          <IconButton
            aria-label="Назад"
            sx={{
              width: '32px',
              height: '32px',
              background: '#EEEEEE',
              borderRadius: '4px',
            }}
            onClick={() => {
              navigate(backUrl)
            }}
          >
            <ArrowBackIcon />
          </IconButton>
        )}
        {backButton}
        <Typography sx={styles.title} variant="h4" component="h4">
          {title}
        </Typography>
        <Box>{status}</Box>
        <Box sx={styles.buttons}>{buttons}</Box>
      </Stack>

      {children && <Box mt={2}>{children}</Box>}
    </Box>
  )
}
